import { createAsyncThunk } from "@reduxjs/toolkit";

import { User } from "src/models/User";

import { axiosInstance as axios } from "../../../../api/axiosInstance";
import { format422 } from "../../../../utils/format422/format422";
import { showSnackbar } from "../../../reducers/snackbar/snackbarSlice";

export const updateUserState = createAsyncThunk(
  "updateUserState",
  async(user: User | undefined, thunkAPI) => {
    const { dispatch, rejectWithValue } = thunkAPI;

    return axios.post(`/api/v1/users/${user?.id}/update-state`, {
      state: Number(!user?.is_active)
    })
      .then((resp) => {
        dispatch(showSnackbar({
          message: "User updated successfully",
          variant: "success"
        }));

        return resp.data;
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const errorMessage = format422(err.response.data.errors);

          dispatch(showSnackbar({
            message: errorMessage,
            variant: "error"
          }));

          return rejectWithValue(errorMessage);
        }

        const errorMessage = "There was an error when updating the user";

        dispatch(showSnackbar({
          message: errorMessage,
          variant: "error"
        }));

        return rejectWithValue(errorMessage);
      });
  }
);
